module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-300.f2fc1c9b.png";